import SubcategoriesSection from './SubcategoriesSection';

export default SubcategoriesSection;
